import React from "react";
import { StyledFlex, HeaderHeadline, StyledDropdown } from "./style";
import {
  StyledSearchBar,
  StyledFilterButton,
  StyledSortIcon,
} from "../../../../components/common";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/WhitePlus.svg";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../store/config";
import { Button, Space } from "antd";
import { useTranslation } from "react-i18next";
import { StyledFiltersBar } from "../../../../components/common/styles";
import { SortType } from "../../../../interfaces/screens/fetch-params-types";

export const Header = (props: {
  search: string;
  setSearch: (search: string) => void;
  setSort: (sort: SortType) => void;
}) => {
  const { search, setSearch, setSort } = props;

  const { t } = useTranslation();
  const navigate = useNavigate();

  const { tableState } = useAppSelector((state) => state.trainers);
  const currentSortBy = tableState.sort.sortBy;

  const handleCreateNewTrainer = () => {
    navigate("/trainers/add");
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const handleSort = (e: any) => {
    setSort({ sortBy: e.key, sortOrder: e.key === "updatedAt" ? -1 : 1 });
  };

  const sortByOptions = [
    {
      key: "fullName",
      label: t("Sort by A-Z"),
    },
    {
      key: "updatedAt",
      label: t("Sort by Last Update"),
    },
  ];

  return (
    <StyledFlex>
      <HeaderHeadline>{t("Trainers")}</HeaderHeadline>
      <StyledFiltersBar>
        <Button
          type="primary"
          shape="round"
          icon={<PlusIcon width={8} height={8} />}
          iconPosition="end"
          onClick={handleCreateNewTrainer}
        >
          {t("Create New Trainer")}
        </Button>
        <StyledSearchBar
          placeholder={t("Search") + "..."}
          value={search}
          onChange={handleSearchChange}
          allowClear
        />
        <StyledDropdown
          menu={{
            items: sortByOptions,
            onClick: handleSort,
            selectedKeys: [currentSortBy],
          }}
          trigger={["click"]}
          placement="bottomRight"
          overlayStyle={{ width: 150, direction: "rtl" }}
        >
          <Space>
            <StyledFilterButton type="text" icon={<StyledSortIcon />}>
              {t("Sort")}
            </StyledFilterButton>
          </Space>
        </StyledDropdown>
      </StyledFiltersBar>
    </StyledFlex>
  );
};
